export const CAST_PER_PAGE = 6;
